//  src/helpers/filters.js

import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatDateTimeShort', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM HH:mm')
  }
})

Vue.filter('truncate', function (text, length, clamp) {
  clamp = clamp || '...'
  return text && text.length > length ? text.substring(0, length) + clamp : text
})
